import * as tslib_1 from "tslib";
import { geometry, GradientStop, Group, LinearGradient, Rect } from '@progress/kendo-drawing';
import { ESRI } from '../esri-loader-util';
import { LayerService } from '../services/layer.service';
import { HeatmapConfig, HeatmapMode } from '../types';
import * as i0 from "@angular/core";
import * as i1 from "./layer.service";
var RectGeometry = geometry.Rect, Point = geometry.Point, Size = geometry.Size, transform = geometry.transform;
var HeatmapRenderer;
var HeatmapService = /** @class */ (function () {
    function HeatmapService(layerService) {
        this.layerService = layerService;
        this.isInitialized = false;
        this.tempLayers = [];
        this.heatmapConfig = new HeatmapConfig();
    }
    HeatmapService.prototype.initializeHeatmapSymbol = function (heatmapRenderer) {
        var e_1, _a;
        var canvas = document.createElement('canvas'), ctx = canvas.getContext('2d'), grd = ctx.createLinearGradient(0, 0, 20, 0);
        var i = 0;
        try {
            for (var _b = tslib_1.__values(heatmapRenderer.colorStops), _c = _b.next(); !_c.done; _c = _b.next()) {
                var colorStop = _c.value;
                grd.addColorStop(i++, colorStop.color.toString());
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        ctx.fillStyle = grd;
        ctx.fillRect(0, 5, 20, 20);
    };
    HeatmapService.prototype.getHeatmapRenderer = function (renderer) {
        if (renderer === void 0) { renderer = null; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var heatmapRenderer;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ESRI.HeatmapRenderer];
                    case 1:
                        HeatmapRenderer = _a.sent();
                        if (renderer) {
                            heatmapRenderer = new HeatmapRenderer(renderer);
                        }
                        else {
                            heatmapRenderer = new HeatmapRenderer(this.heatmapConfig.defaultOptions);
                        }
                        return [2 /*return*/, heatmapRenderer];
                }
            });
        });
    };
    HeatmapService.prototype.getEsriColor = function (color) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var Color;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ESRI.Color];
                    case 1:
                        Color = _a.sent();
                        if (!color) {
                            return [2 /*return*/, null];
                        }
                        else if (color.declaredClass === 'esri.Color') {
                            return [2 /*return*/, color];
                        }
                        else if (typeof color === 'string') {
                            if (color.indexOf('rgb') === 0) {
                                return [2 /*return*/, Color.fromRgb(color)];
                            }
                            else {
                                return [2 /*return*/, Color.fromString(color)];
                            }
                        }
                        else if (Array.isArray(color)) {
                            return [2 /*return*/, new Color(color)];
                        }
                        else if (color.r !== undefined && color.g !== undefined && color.b !== undefined) {
                            return [2 /*return*/, new Color([color.r, color.g, color.b, color.a])];
                        }
                        else {
                            return [2 /*return*/, new Color({})];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    HeatmapService.prototype.getColorString = function (color, background, transparent) {
        if (background === void 0) { background = true; }
        if (transparent === void 0) { transparent = false; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var Color, c;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ESRI.Color];
                    case 1:
                        Color = _a.sent();
                        if (background) {
                            c = Color.fromString(color).toRgba();
                            if (transparent) {
                                c[3] = 0;
                            }
                            else {
                                c[3] = 1;
                            }
                            return [2 /*return*/, "rgba(" + c.join(',') + ")"];
                        }
                        else {
                            return [2 /*return*/, "rgb(" + Color.fromString(color).toRgb().join(',') + ")"];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    HeatmapService.prototype.updateHeatmapLayers = function (layer, heatmapRenderer) {
        if (heatmapRenderer === void 0) { heatmapRenderer = null; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var newLayer, heatmapMode, _a, index, _b, heatmapOn;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        newLayer = null;
                        heatmapMode = layer.mapcoreProps.heatmapMode;
                        if (!(layer && layer.type === 'map-image' && heatmapMode !== HeatmapMode.Off)) return [3 /*break*/, 4];
                        if (!(layer.sublayers.length === 1)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.layerService.convertToFeatureLayer(layer)];
                    case 1:
                        newLayer = _c.sent();
                        _a = newLayer.mapcoreProps;
                        return [4 /*yield*/, this.getHeatmapRenderer(heatmapRenderer)];
                    case 2:
                        _a.heatmapRenderer = _c.sent();
                        newLayer.mapcoreProps.renderer = newLayer.renderer;
                        if (this.layerService.checkIfHeatmapIsOnOrOff(newLayer)) {
                            newLayer.renderer = newLayer.mapcoreProps.heatmapRenderer;
                        }
                        newLayer.mapcoreProps.url = undefined;
                        index = this.layerService.getLayerIndex(layer);
                        this.layerService.removeLayer(layer);
                        this.layerService.addLayer(newLayer, index);
                        return [2 /*return*/, newLayer];
                    case 3: return [3 /*break*/, 10];
                    case 4:
                        if (!(layer && heatmapMode === HeatmapMode.Off && layer.type === 'feature')) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.layerService.convertToImagelayer(layer)];
                    case 5:
                        newLayer = _c.sent();
                        this.layerService.removeLayerById(layer.id);
                        newLayer.mapcoreProps.heatmapMode = heatmapMode;
                        return [2 /*return*/, newLayer];
                    case 6:
                        if (!(layer && heatmapMode === HeatmapMode.On && layer.mapcoreProps.renderer)) return [3 /*break*/, 9];
                        layer.mapcoreProps.heatmapMode = heatmapMode;
                        if (!!layer.mapcoreProps.heatmapRenderer) return [3 /*break*/, 8];
                        _b = layer.mapcoreProps;
                        return [4 /*yield*/, this.getHeatmapRenderer(heatmapRenderer)];
                    case 7:
                        _b.heatmapRenderer = _c.sent();
                        layer.mapcoreProps.renderer = newLayer.renderer;
                        _c.label = 8;
                    case 8:
                        layer.renderer = layer.mapcoreProps.heatmapRenderer;
                        return [3 /*break*/, 10];
                    case 9:
                        if (layer && heatmapMode === HeatmapMode.Auto) {
                            layer.mapcoreProps.heatmapMode = heatmapMode;
                            heatmapOn = this.layerService.checkIfHeatmapIsOnOrOff(layer);
                            if (heatmapOn) {
                                layer.renderer = layer.mapcoreProps.heatmapRenderer;
                            }
                            else {
                                layer.renderer = layer.mapcoreProps.renderer;
                            }
                        }
                        _c.label = 10;
                    case 10: return [2 /*return*/, layer];
                }
            });
        });
    };
    HeatmapService.prototype.drawScene = function (surface, startColor, endColor) {
        surface.clear();
        var gradient = new LinearGradient({
            name: 'grd',
            stops: [
                new GradientStop(0, startColor, 1),
                new GradientStop(1, endColor, 1)
            ]
        });
        // This rectangle demonstrates how to use the gradient as a fill.
        var rect = new RectGeometry(new Point(0, 0), new Size(400, 36));
        var drawingRect = new Rect(rect, {
            stroke: {
                color: '#9999b6',
                width: 1
            },
            fill: gradient // fill accepts gradients but not supported in Kendo typings
        });
        // Place all the shapes in a group.
        var group = new Group();
        group.append(drawingRect);
        // Translate the group.
        group.transform(transform().translate(5, 0));
        // Render the group on the surface.
        surface.draw(group);
    };
    HeatmapService.ngInjectableDef = i0.defineInjectable({ factory: function HeatmapService_Factory() { return new HeatmapService(i0.inject(i1.LayerService)); }, token: HeatmapService, providedIn: "root" });
    return HeatmapService;
}());
export { HeatmapService };
